function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { EventEmitter } from 'events';
import { getWebsocketToken } from '@/actions/ChannelActions';
import { AuthProviders } from '@/types/server';
import { UserLevels } from '../../../common/db/constants';
import useChannelStore from '@/stores/ChannelStore';
var _process_env_WEBSOCKET_ENDPOINT;
var WEBSOCKET_URL = (_process_env_WEBSOCKET_ENDPOINT = process.env.WEBSOCKET_ENDPOINT) !== null && _process_env_WEBSOCKET_ENDPOINT !== void 0 ? _process_env_WEBSOCKET_ENDPOINT : 'wss://ws.nightbot.tv/ws';
var testMessageIndex = 0;
export function generateTestChatMessages(socket) {
    var channel = useChannelStore.getState().channel;
    if (channel == null) {
        return;
    }
    var testUserLevels = [
        UserLevels.moderator,
        UserLevels.regular,
        UserLevels.subscriber,
        UserLevels.everyone
    ];
    if (channel.provider === AuthProviders.TWITCH) {
        testUserLevels.push(UserLevels.twitch_vip);
    }
    if (channel.provider === AuthProviders.SOOP) {
        testUserLevels.push(UserLevels.soop_vip);
    }
    for(var userId = 0; userId < 1000; userId++){
        var userLevel = testUserLevels[userId % testUserLevels.length];
        var message = {
            date: new Date().toISOString(),
            messageId: crypto.randomUUID(),
            message: "".concat(testMessageIndex++),
            action: false,
            chatId: 'test',
            filtering: true,
            commands: true,
            channel: {
                name: channel.name,
                // @ts-expect-error test data
                provider: channel.provider,
                providerId: channel.providerId,
                displayName: channel.displayName,
                _id: channel._id
            },
            user: {
                // @ts-expect-error test data
                provider: channel.provider,
                providerId: "test_".concat(userId),
                name: "test_".concat(userId),
                displayName: "Test User ".concat(userId),
                // @ts-expect-error test data
                userType: userLevel,
                regular: userLevel === UserLevels.regular,
                subscriber: userLevel === UserLevels.subscriber,
                moderator: userLevel === UserLevels.moderator,
                vip: userLevel === UserLevels.twitch_vip || userLevel === UserLevels.soop_vip,
                emotesUsed: 0
            }
        };
        socket.emit('chatMessage', message);
    }
}
function backoffTimeout(attempt) {
    return Math.min(60000, Math.pow(2, attempt) * 1000);
}
var SocketClient = /*#__PURE__*/ function(EventEmitter) {
    "use strict";
    _inherits(SocketClient, EventEmitter);
    function SocketClient(channelId) {
        _class_call_check(this, SocketClient);
        var _this;
        _this = _call_super(this, SocketClient), _define_property(_this, "socket", null), _define_property(_this, "channelId", void 0), _define_property(_this, "disconnected", false);
        _this.channelId = channelId;
        _this.connect();
        return _this;
    }
    _create_class(SocketClient, [
        {
            key: "connect",
            value: function connect() {
                var attempt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                var _this = this;
                return _async_to_generator(function() {
                    var token, _, url, socket, handleReconnect;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.socket != null) {
                                    return [
                                        2
                                    ];
                                }
                                token = null;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    getWebsocketToken({
                                        channelId: _this.channelId
                                    })
                                ];
                            case 2:
                                token = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _ = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                if (token == null || typeof token !== 'string') {
                                    setTimeout(function() {
                                        return _this.connect(attempt + 1);
                                    }, backoffTimeout(attempt));
                                    return [
                                        2
                                    ];
                                }
                                url = new URL(WEBSOCKET_URL);
                                url.searchParams.set('token', token);
                                url.searchParams.set('channel', _this.channelId);
                                socket = new WebSocket(url.toString());
                                _this.socket = socket;
                                _this.socket.addEventListener('message', function(event) {
                                    try {
                                        var payload = JSON.parse(event.data);
                                        if (typeof payload.event !== 'string') {
                                            return;
                                        }
                                        _this.emit(payload.event, payload.data);
                                    } catch (error) {}
                                });
                                handleReconnect = function() {
                                    if (_this.socket !== socket) {
                                        return;
                                    }
                                    _this.disconnect();
                                    setTimeout(function() {
                                        return _this.connect(attempt + 1);
                                    }, backoffTimeout(attempt));
                                };
                                _this.socket.addEventListener('close', function() {
                                    return handleReconnect();
                                });
                                _this.socket.addEventListener('error', function() {
                                    return handleReconnect();
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.socket == null) {
                    return;
                }
                try {
                    this.socket.close();
                } catch (_) {}
                this.socket = null;
            }
        }
    ]);
    return SocketClient;
}(EventEmitter);
export default SocketClient;
